import {
  AnyUserEntityVersion,
  Collections,
  FirestoreEntity,
  Mapper,
  User,
} from '@uploadcam/common';
import { CollectionReference, doc, Firestore, getDoc } from 'firebase/firestore';
import invariant from 'tiny-invariant';
import { getCollectionRef } from '../../../../@harmony/angular';

export class GetUserByIdInteractor {
  private readonly collection: CollectionReference<AnyUserEntityVersion>;

  constructor(
    private readonly db: Firestore,
    private readonly mapper: Mapper<FirestoreEntity<AnyUserEntityVersion>, User>,
  ) {
    this.collection = getCollectionRef(this.db, Collections.Users);
  }

  public async execute(id: string): Promise<User> {
    const userRef = doc(this.collection, id);
    const userDoc = await getDoc(userRef);
    const userData = userDoc.data();

    invariant(typeof userData !== 'undefined', 'Empty user data');

    return this.mapper.map(FirestoreEntity.from(userDoc));
  }
}
